/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useLazyQuery, gql } from '@apollo/client';
import { useTokenContext } from "@exo/frontend-common-app-identity-and-access";

const validateOrder = gql`
query ValidateOrdTrack($orderId: String!, $email: String!) {
  validateOrderTracking(orderId: $orderId, emailId: $email) {
    orderId
    isValid
  }
}
`;
export const  useOrderStatus =  () => {
  const tokenContext = useTokenContext();
   tokenContext.ensureValidToken();
  const [getOrderStatusDetails, trackingOrderDetail] = useLazyQuery(validateOrder);
  return { getOrderStatusDetails, trackingOrderDetail };
};
